const notShowHierarchyFilter = ['TextBlock'];

export default notShowHierarchyFilter;
